import React from 'react';
import PropTypes from 'prop-types';
import { PopOver, Tooltip } from 'components';
import { ReactComponent as Profile } from 'assets/icons/profile.gov.svg';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../../../../../store/user/actions';
import { getLocalString, localNames } from "utils/localisation.service";
import isEmpty from 'lodash/isEmpty';

const Logout = ({ visible, setVisible, user }) => {
const dispatch = useDispatch();
const locales = useSelector(state => state.forms?.localeStrings);
 
  return (
    <PopOver
      open={visible}
      onOpenChange={setVisible}
      placement="bottom"
      autoAdjustOverflow={true}
      overlayStyle={{
        left: '50%',
        zIndex: 1000
      }}
      TriggerComponent={
        <Tooltip placement="right" title="User Profile" className="header-profile-icon">
          <Profile/>
        </Tooltip>
      }
    >
       <div className="logout-popover__body">
        <div className="fullname">{user.fullName}</div>
        {user.roleDescription && (
          <div className="role">{user.roleDescription}</div>
        )}
        <div className="logout" onClick={() => {
            //maybe change the condition below to just (user?.taxis_data?.afm) ?
            if (isEmpty(user?.taxis_data) || Object.values(user?.taxis_data)?.every(p => isEmpty(p)) || window.location.hostname.includes('localhost')) {
              dispatch(logoutUser());
          } else {
              window.open(process.env.REACT_APP_TAXIS_LOGOUT, '_self');
           }            
          }}>
          {getLocalString(locales, localNames.HOME_PAGE_LOGOUT)}
        </div>
      </div>
    </PopOver>
  );
};

Logout.propTypes = {
  open: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default Logout;
